import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "consent-popup" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-body" }
const _hoisted_5 = { class: "contents_body" }
const _hoisted_6 = { style: {"font-weight":"bold"} }
const _hoisted_7 = { class: "popup-footer" }

import { ref, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SealConsentPop',
  props: {
    사업자명: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const 사업자명 = ref<string | null>(null);
// 컴포넌트가 마운트될 때 props.status 값을 초기화
onMounted(() => {
  사업자명.value = props.사업자명;
});


// 선택한 상태를 부모 컴포넌트로 emit
const confirmSelection = (flag: boolean) => {
  
  emit("closePopup", { popupType: "consent", refresh: false, selectedData: flag });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "popup_cover" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "popup_title" }, "사용인감 동의서", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmSelection(false))),
          class: "close_icon"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createTextVNode(" 본인은 [")),
          _createElementVNode("span", _hoisted_6, _toDisplayString(사업자명.value), 1),
          _cache[4] || (_cache[4] = _createTextVNode("]에서 요구하는 제반 업무 및 계약 등에 있어 사용인감을 사용하는 것에 동의합니다. 이에 따라 본인이 날인한 사용인감은 법적 효력을 가지며, 이에 대한 모든 책임은 본인에게 있음을 확인합니다. "))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "popup_confirm_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmSelection(true)))
        }, "동의")
      ])
    ])
  ]))
}
}

})